import React from 'react';
import { ArrowRight, ChevronRight, Lock } from 'lucide-react';

const Status = ({ it }) => (it.on ? null : <span className="text-[10px] uppercase tracking-wider opacity-70 inline-flex items-center gap-1"><Lock size={11} />{it.status}</span>);

function Pills({ items, testPrefix }) {
  return (
    <div className="flex flex-nowrap sm:flex-wrap gap-2 mb-6 overflow-x-auto -mx-5 px-5 sm:mx-0 sm:px-0 pb-1 [scrollbar-width:none]" data-testid={`${testPrefix}-buttons`}>
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <button key={it.id} onClick={it.click} data-testid={`${testPrefix}-${it.id}`}
            className={`group shrink-0 whitespace-nowrap h-11 pl-1.5 pr-4 rounded-full border inline-flex items-center gap-2.5 text-sm transition-[background-color,border-color,transform] duration-200 hover:-translate-y-0.5 ${it.on ? 'border-current/20 bg-white/60 hover:bg-white' : 'border-dashed opacity-70 hover:opacity-100'}`}
            style={{ color: it.tone, borderColor: `${it.tone}55` }}>
            <span className="w-8 h-8 rounded-full grid place-items-center text-white" style={{ background: it.on ? it.tone : '#9AA0A6' }}><Icon size={15} /></span>
            <span className="font-medium text-[#14161A]">{it.label}</span>
            {it.on ? <ArrowRight size={15} className="transition-transform group-hover:translate-x-0.5" /> : <Status it={it} />}
          </button>
        );
      })}
    </div>
  );
}

function Tiles({ items, testPrefix }) {
  return (
    <div className="grid grid-cols-4 gap-2 sm:gap-3 mb-6 max-w-2xl" data-testid={`${testPrefix}-buttons`}>
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <button key={it.id} onClick={it.click} data-testid={`${testPrefix}-${it.id}`}
            className={`group relative rounded-lg border border-[#E3DED2] bg-white px-2 pt-3 pb-2.5 flex flex-col items-center gap-1.5 text-center transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-md ${it.on ? '' : 'opacity-60'}`}
            style={{ borderTop: `3px solid ${it.on ? it.tone : '#C9CCD1'}` }}>
            <Icon size={20} style={{ color: it.on ? it.tone : '#8A8F97' }} />
            <span className="text-[11px] sm:text-xs font-medium leading-tight text-[#14161A]">{it.label}</span>
            {!it.on && <Lock size={10} className="absolute top-1.5 right-1.5 text-[#8A8F97]" />}
          </button>
        );
      })}
    </div>
  );
}

function Segmented({ items, testPrefix }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 rounded-xl overflow-hidden border border-[#E3DED2] bg-white mb-6 divide-x divide-y lg:divide-y-0 divide-[#E3DED2]" data-testid={`${testPrefix}-buttons`}>
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <button key={it.id} onClick={it.click} data-testid={`${testPrefix}-${it.id}`}
            className={`group relative h-14 px-4 flex items-center gap-3 text-left transition-colors duration-200 hover:bg-[#FBFAF6] ${it.on ? '' : 'opacity-60'}`}>
            <span className="absolute left-0 inset-y-2 w-1 rounded-r" style={{ background: it.on ? it.tone : '#C9CCD1' }} />
            <Icon size={18} style={{ color: it.on ? it.tone : '#8A8F97' }} />
            <span className="flex-1 text-sm font-medium text-[#14161A] leading-tight">{it.label}</span>
            {it.on ? <ChevronRight size={16} className="text-[#8A8F97] transition-transform group-hover:translate-x-0.5" /> : <Status it={it} />}
          </button>
        );
      })}
    </div>
  );
}

function DarkChips({ items, testPrefix }) {
  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-2 sm:gap-3 mb-6" data-testid={`${testPrefix}-buttons`}>
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <button key={it.id} onClick={it.click} data-testid={`${testPrefix}-${it.id}`}
            className={`group relative overflow-hidden h-14 rounded-md px-4 flex items-center gap-3 text-left border transition-[border-color,transform] duration-200 hover:-translate-y-0.5 ${it.on ? '' : 'opacity-60'}`}
            style={{ background: '#14161A', borderColor: '#2A2F37' }}>
            <span className="absolute inset-y-0 -left-1/2 w-1/3 bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-[-20deg] transition-[left] duration-700 group-hover:left-[120%]" />
            <Icon size={18} style={{ color: '#D4AF37' }} />
            <span className="flex-1 text-sm leading-tight" style={{ color: '#FFFFFF' }}>{it.label}</span>
            {it.on ? <ArrowRight size={15} style={{ color: '#D4AF37' }} /> : <span style={{ color: '#8A8F97' }}><Status it={it} /></span>}
          </button>
        );
      })}
    </div>
  );
}

export const VARIANTS = { a: Pills, b: Tiles, c: Segmented, d: DarkChips };
